import React from "react";

import CartPerShopSkeleton from "../../molecules/CartPerShop/skeleton";

const CartPageSkeleton = () => <CartPerShopSkeleton />

export default CartPageSkeleton;